export default {
  header: {
    app: '菁客手机应用',
    candidate: '求职者',
    employer: '招聘解决方案',
    intelligence: '菁客智能',
    login: '登录',
    hotline: {
      cnUser: '中国大陆用户',
      allUser: '全部用户'
    },
    userMenu: {
      searchJob: '搜索职位',
      myHomePage: '我的个人主页',
      recruitingManagement: '招聘管理',
      home: '首页',
      companyJobList: '招聘管理',
      crmManagement: '求职者关系管理',
      editCompanyProfile: '修改公司信息',
      editCompanyCulture: '修改公司文化',
      changePassword: '修改密码',
      systemNotification: '站内消息',
      logout: '退出'
    }
  },
  footer: {
    home: '主页',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    privacyPolicy: '用户协议与隐私政策'
  },
  newLayout: {
    menu: {
      hrDashboard: '总览',
      applicantList: '候选人申请',
      applicantProfile: '候选人信息',
      jobList: '职位',
      talentPool: '人才库',
      crm: '求职者关系管理',
      referral: '推荐',
      interview: '面试管理',
      charReport: '报表',
      companyAdmin: '管理后台',
      rpa: 'RPA',
      apScheduler: '定时任务管理',
      clientAdmin: '客户管理',
      chatBot: '聊天机器人',
      hrReport: '数据',
      potentialList: '潜在候选人',
      potentialProfile: '潜在候选人信息',
      AgencyApplicationList: '猎头上传候选人列表',
      AgencyApplicationProfile: '猎头上传候选人信息'
    },
    candidateMenu: {
      applications: '操作中心',
      assessment: '评估',
      myReport: '我的报告',
      profile: '我的档案',
      policy: '我的授权',
      referral: '我的奖励和推荐',
      aboutReferral: '关于推荐计划',
      changeEmail: '更改邮箱',
      bindMobile: '绑定手机'
    }
  }
}
